import $ from "jquery";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { createNav } from "../sliders";

const arrow = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.1 22.7" style="enable-background:new 0 0 12.1 22.7;" xml:space="preserve"><path d="M10.6,11.4L0,0.7L0.7,0l11.4,11.4L0.7,22.7L0,22L10.6,11.4z"/></svg>`;
let imageSlider

const modalSliderInit = (initialSlide) => {
  imageSlider = new Swiper(".modal-preview__slider .swiper", {
    modules: [Navigation],
    slidesPerView: 1,
    initialSlide,
    loop: true,
    navigation: {
      prevEl: ".modal-preview__slider .slick-prev",
      nextEl: ".modal-preview__slider .slick-next",
    },
  });
}
/**
 * @param {String[]} imagesArr - Array of images src
 * @param {Number} goTo - Index of the image to go to
 * @param {Array} alt - Array of alt texts
 * @param {Array} webpArr - Array of webp images
 * @param {Object} options - Additional options
 * @param {Boolean} options.disabled - Whether the product is disabled
 * @returns {void}
 **/
const modalPreviewSlider = (imagesArr, goTo, alt, webpArr, options = {}) => {
  const images = imagesArr.map(
    (item, key) =>
      `<div class="modal-slider-item swiper-slide ${options.disabled ? "disabled" : ""}">
        <picture>
          ${ webpArr[key] ? `<source srcset="${webpArr[key]}" type="image/webp">` : "" }
          <img src="${item}" alt="${alt[key]}">
        </picture>
      </div>`
  );
  const modal = `
    <div class="modal modal-preview-slider">
      <div class="modal__zoom">
        <div class="modal-content">
          <div class="close-btn js-close"></div>
          <div class="modal-preview__slider">
            <div class="swiper" style="height: 100%">
              <div class="swiper-wrapper">
                ${images.join("")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  document.querySelector(".modal-preview-slider")?.remove();

  if (!$(".modal-preview-slider").length) {
    $("body").append(modal);
    images.length > 1 && createNav($(".modal-preview__slider")[0], { arrow });
    requestAnimationFrame(() => {
      modalSliderInit(goTo);
    });
  } else {
    imageSlider.slideToLoop(goTo);
  }

  $(".modal-preview-slider").fadeIn(300);
  $("html").addClass("overflow");
};

export default modalPreviewSlider;
